import React, { useEffect, useRef } from 'react';
import { paintDotGrid } from './dotGridPainter';

export const DotGridBackground = () => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) { canvas.dataset.renderMode = 'fallback'; return undefined; }
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    let frame = 0, width = 0, height = 0, interactive = false, disposed = false;
    let current = { x: 0, y: 0, power: 0 };
    let target = { ...current };
    const draw = () => paintDotGrid(ctx, width, height, current);
    const stop = () => { cancelAnimationFrame(frame); frame = 0; };
    const animate = () => {
      frame = 0;
      if (disposed || document.hidden) return;
      const delta = Math.abs(current.x - target.x) + Math.abs(current.y - target.y) + Math.abs(current.power - target.power) * 100;
      current.x += (target.x - current.x) * .16;
      current.y += (target.y - current.y) * .16;
      current.power += (target.power - current.power) * .12;
      if (delta < .12) current = { ...target };
      draw();
      if (delta >= .12 && interactive) frame = requestAnimationFrame(animate);
    };
    const schedule = () => { if (!frame && !disposed && !document.hidden) frame = requestAnimationFrame(animate); };
    const resize = () => {
      stop();
      const rect = canvas.getBoundingClientRect();
      width = rect.width; height = rect.height;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      current = { x: width * .68, y: height * .45, power: 0 };
      target = { ...current };
      interactive = fine.matches && !reduced.matches;
      canvas.dataset.renderMode = reduced.matches ? 'reduced-motion' : interactive ? 'interactive' : 'static';
      draw();
      canvas.dataset.ready = 'true';
    };
    const move = event => {
      if (!interactive || event.pointerType === 'touch') return;
      target = { x: event.clientX, y: event.clientY, power: 1 };
      schedule();
    };
    const leave = () => { target.power = 0; if (interactive) schedule(); };
    const visibility = () => { if (document.hidden) stop(); else resize(); };
    resize();
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('resize', resize);
    window.addEventListener('blur', leave);
    document.documentElement.addEventListener('pointerleave', leave);
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', resize); fine.addEventListener('change', resize);
    return () => {
      disposed = true; stop();
      window.removeEventListener('pointermove', move);
      window.removeEventListener('resize', resize);
      window.removeEventListener('blur', leave);
      document.documentElement.removeEventListener('pointerleave', leave);
      document.removeEventListener('visibilitychange', visibility);
      reduced.removeEventListener('change', resize); fine.removeEventListener('change', resize);
    };
  }, []);
  return <div className="sr-background" aria-hidden="true" data-testid="signup-review-background">
    <canvas ref={canvasRef} data-testid="signup-review-dot-canvas" className="sr-dot-canvas" />
  </div>;
};